<div class="container">

  <app-header-dialog [iconName]="'ballot'">
    <span>vv Anuidade - {{ordered.member_name}} - {{ order_date | date:'dd/MM/yyyy' }}</span>
  </app-header-dialog>

  <div class='content'>

    <mat-card>
      <div class='order-item'>
        <div class='label'>
          Data:
        </div>
        <div class='value'>
          {{ order_date | date:'dd/MM/yyyy' }}
        </div>

      </div>

      <div class='order-item'>
        <div class='label'>
          Produto:
        </div>
        <div class='value'>
          {{ ordered.product_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Cliente:
        </div>
        <div class='value'>
          {{ ordered.member_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Categoria:
        </div>
        <div class='value'>
          {{ ordered.category_name }}
        </div>
      </div>

      <div class='order-item' *ngIf='ordered.member_debit > 0'>
        <div class='label'>
          Débito:
        </div>
        <div class='value'>
          {{ ordered.member_debit | currency:'BRL':'':'1.2-2' }}
        </div>
      </div>

      <div class='order-item' *ngIf='payment_type_display'>
        <div class='label'>
          Tipo:
        </div>
        <div class='value'>
          {{ payment_type_display }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Origem:
        </div>
        <div class='value'>
          {{ ordered.origin }}
        </div>
      </div>

    </mat-card>

    <mat-card>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Tid</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.Tid"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.Tid.hasError('required')">
          O Tid é obrigatório
        </mat-error>
      </mat-form-field>

      <div style="display: flex; flex-direction: row; justify-content: space-between;">

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Valor</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.value" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.value.hasError('required')">
            O Valor é obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Desconto</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.discount" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.discount.hasError('required')">
            O Desconto é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Taxa</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.tax" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.tax.hasError('required')">
            O Taxa é obrigatória
          </mat-error>
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Total</mat-label>
          <input matInput type="number" (blur)='calcValue()' [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.total_minus_tax" placeholder="Total" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.total_minus_tax.hasError('required')">
            O Total é obrigatório
          </mat-error>
        </mat-form-field>

      </div>

    </mat-card>

  </div>

  <div class="actions">

    <div [ngClass]="{hidden: !_orderedService.spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button *ngIf='!this.new_order' mat-raised-button (click)='updateOrder()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>